// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite } from 'pixi.js';
import { RocketBlockerRocketLayout } from './RocketBlockerRocketLayout';

const raw = {
  width: 664,
  height: 667,
  x: 0,
  y: 0,
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      runtimeType: null,
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: null,
      stateByName: {}
    },
    {
      id: 'd30c998a-42ee-4744-92b7-e00121fd79e8',
      type: 'Container',
      runtimeType: null,
      name: 'canisters',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: '166397c9-aa8a-411a-97ba-909a7a241079',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.55,
        y: 0.55
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Rocket_Canisters_Shadow',
      parent: 'd30c998a-42ee-4744-92b7-e00121fd79e8',
      stateByName: {},
      data: undefined
    },
    {
      id: '2c0364bb-5cfc-40ce-9a9b-edbfa5ffdef2',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Rocket_Canisters',
      parent: 'd30c998a-42ee-4744-92b7-e00121fd79e8',
      stateByName: {},
      data: undefined
    },
    {
      id: '52c51b0b-2c4f-4bd7-80f2-fcb06d1fe554',
      type: 'Sprite',
      runtimeType: null,
      name: 'whiteOverlay',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Rocket_Canisters_White',
      parent: 'd30c998a-42ee-4744-92b7-e00121fd79e8',
      stateByName: {},
      data: undefined
    },
    {
      id: 'd3b352f1-88d5-4cb7-a3aa-f0ac9551aa85',
      type: 'Container',
      runtimeType: null,
      name: 'rockets',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'd30c998a-42ee-4744-92b7-e00121fd79e8',
      stateByName: {},
      data: undefined
    },
    {
      id: '73c39eb6-99b5-443b-8847-3fcbba073049',
      type: 'Layout',
      runtimeType: null,
      name: 'rocketTop',
      className: '',
      path: 'blockers/RocketBlockerRocketLayout.ts',
      percentX: 0,
      percentY: 0,
      x: 1,
      y: -38,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: 'd3b352f1-88d5-4cb7-a3aa-f0ac9551aa85',
      data: undefined,
      stateByName: {}
    },
    {
      id: '841cc5a0-fdd9-48f5-8123-fbed5b3179e9',
      type: 'Sprite',
      runtimeType: null,
      name: 'maskTop',
      className: '',
      x: 1,
      y: -18,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Rocket_Mask',
      parent: 'd3b352f1-88d5-4cb7-a3aa-f0ac9551aa85',
      stateByName: {},
      data: undefined
    },
    {
      id: 'e7e71c5b-5d75-44c6-bec4-d2c855e87cdf',
      type: 'Layout',
      runtimeType: null,
      name: 'rocketRight',
      className: '',
      path: 'blockers/RocketBlockerRocketLayout.ts',
      percentX: 0,
      percentY: 0,
      x: 34,
      y: -14,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: 'd3b352f1-88d5-4cb7-a3aa-f0ac9551aa85',
      data: undefined,
      stateByName: {}
    },
    {
      id: '3e44d1e1-0bad-4a5a-8bae-d6c9de1d75f5',
      type: 'Sprite',
      runtimeType: null,
      name: 'maskRight',
      className: '',
      x: 34,
      y: 6,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Rocket_Mask',
      parent: 'd3b352f1-88d5-4cb7-a3aa-f0ac9551aa85',
      stateByName: {},
      data: undefined
    },
    {
      id: '4e70a856-2299-4f93-b7e3-755ce51a5a4b',
      type: 'Layout',
      runtimeType: null,
      name: 'rocketLeft',
      className: '',
      path: 'blockers/RocketBlockerRocketLayout.ts',
      percentX: 0,
      percentY: 0,
      x: -34,
      y: -14,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: 'd3b352f1-88d5-4cb7-a3aa-f0ac9551aa85',
      data: undefined,
      stateByName: {}
    },
    {
      id: '28bc21e0-fe2a-49e8-8889-3592e1b73b5d',
      type: 'Sprite',
      runtimeType: null,
      name: 'maskLeft',
      className: '',
      x: -34,
      y: 6,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Rocket_Mask',
      parent: 'd3b352f1-88d5-4cb7-a3aa-f0ac9551aa85',
      stateByName: {},
      data: undefined
    },
    {
      id: 'dd3465cc-937c-4522-9064-aa4fc5c7f36c',
      type: 'Layout',
      runtimeType: null,
      name: 'rocketBottom',
      className: '',
      path: 'blockers/RocketBlockerRocketLayout.ts',
      percentX: 0,
      percentY: 0,
      x: 1,
      y: 10,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: 'd3b352f1-88d5-4cb7-a3aa-f0ac9551aa85',
      data: undefined,
      stateByName: {}
    },
    {
      id: '2d9d770e-35c6-4137-a9c7-4560d706a772',
      type: 'Sprite',
      runtimeType: null,
      name: 'maskBottom',
      className: '',
      x: 1,
      y: 30,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Rocket_Mask',
      parent: 'd3b352f1-88d5-4cb7-a3aa-f0ac9551aa85',
      stateByName: {},
      data: undefined
    }
  ],
  version: '1.0.0',
  stateNames: [
    'doors-closed',
    'doors-opened'
  ],
  animations: []
} as const;

export class RocketBlockerLayout {
  static raw = raw;
  root: Container;
  canisters: Container;
  whiteOverlay: Sprite;
  rockets: Container;
  rocketTop: RocketBlockerRocketLayout;
  maskTop: Sprite;
  rocketRight: RocketBlockerRocketLayout;
  maskRight: Sprite;
  rocketLeft: RocketBlockerRocketLayout;
  maskLeft: Sprite;
  rocketBottom: RocketBlockerRocketLayout;
  maskBottom: Sprite;

  mInternalTypes: {
    Raw: typeof raw;
    StateName: 'doors-closed' | 'doors-opened';
    ModelByName: {
      root: typeof raw['list'][0];
      canisters: typeof raw['list'][1];
      whiteOverlay: typeof raw['list'][4];
      rockets: typeof raw['list'][5];
      rocketTop: typeof raw['list'][6];
      maskTop: typeof raw['list'][7];
      rocketRight: typeof raw['list'][8];
      maskRight: typeof raw['list'][9];
      rocketLeft: typeof raw['list'][10];
      maskLeft: typeof raw['list'][11];
      rocketBottom: typeof raw['list'][12];
      maskBottom: typeof raw['list'][13];
    };
  };

  constructor() {
    populate(this, raw);
  }
}
